<style scoped>
th:last-child {
  width: 10px;
}
.h-account {
  min-height: 450px;
}
</style>

<template lang="pug">
.h-account
  .collapsible-header.active
    i.material-icons supervisor_account
    | Staff Accounts
  .row
    .col.s12
      a.waves-effect.btn.btn-flat.right(
        v-on:click='addAccount',
        v-bind:style='{ marginTop: "10px" }'
      )
        i.material-icons.left add
        | Add
  p.center(v-if='!hasAccounts') No accounts available
  //- table.responsive-table.compact.highlight(v-else)
  //-   thead
  //-     th Email
  //-     th User Name
  //-     th First Name
  //-     th Last Name
  //-     th
  //-   tbody
  //-     tr(v-for='(account, index) in accounts')
  //-       td
  //-         a(href='#', @click='showAccount(account, index)') {{ account.email }}
  //-       td
  //-         p {{ account.localMembership.username }}
  //-       td
  //-         p {{ account.firstName }}
  //-       td
  //-         p {{ account.lastName }}
  //-       td
  //-         a.btn-flat.waves-effect(@click='confirmAccountRemoval(index)')
  //-           i.material-icons.red-text remove
  v-app
    v-card
      v-card-text
        v-data-table(
          :headers='headers',
          :items='accounts',
          :pagination.sync='pagination',
          :total-items='pagination.totalItems',
          :loading='isLoading',
          prev-icon='arrow_left',
          next-icon='arrow_right',
          sort-icon='arrow_drop_up'
        )
          v-progress-linear(v-slot='progress', color='blue', indeterminate)
          template(v-slot:items='props')
            td.text-xs-left {{ props.item.email }}
            td.text-xs-left {{ props.item.localMembership.username }}
            td.text-xs-left {{ props.item.firstName }}
            td.text-xs-left {{ props.item.lastName }}
            td.text-xs-left {{ props.item.status }}

  //- pre {{accounts}}
</template>
<script>
import AppAccountDetails from '@/components/app-account-details'
import axios from 'axios'

export default {
  props: ['supplier'],
  data() {
    return {
      deleteAccountModal: null,
      account: null,
      accountIndex: null,
      accounts: this.supplier.accounts,
      headers: [
        { text: 'Email', value: 'email', width: '40%' },
        { text: 'Username', value: 'username', width: '20%' },
        { text: 'First Name', value: 'firstName', width: '20%' },
        { text: 'Last Name', value: 'lastName', width: '20%' },
        { text: 'Status', value: 'status', width: '20%' },
      ],
      pagination: {
        descending: true,
        sortBy: 'firstName',
      },
      isLoading: false,
      totalItems: 0,
    }
  },
  created() {
    this.getAccounts()
  },
  computed: {
    hasAccounts() {
      return this.accounts && this.accounts.length
    },
    newAccount() {
      return this.account && !this.account.uid
    },
  },
  methods: {
    resetAccount() {
      this.account = null
      this.accountIndex = null
    },
    showAccount(account, index) {
      this.account = account
      this.accountIndex = index

      const modalParams = {
        content: AppAccountDetails,
        bind: {
          account: account,
          onSave: this.saveAccount,
          onCancel: this.closeModal,
        },
        style: {
          padding: 'medium',
        },
      }
      this.$store.dispatch('modal/open', modalParams)
    },
    addAccount() {
      const modalParams = {
        content: AppAccountDetails,
        bind: {
          account: { email: null, firstName: null, lastName: null },
          isNewAccount: true,
          onSave: this.saveAccount,
          onCancel: this.closeModal,
        },
        style: {
          padding: 'medium',
        },
      }

      this.$store.dispatch('modal/open', modalParams)
    },
    closeModal() {
      this.account = null
      this.accountIndex = null
      this.$store.dispatch('modal/close')
    },
    saveAccount(account, isNew) {
      this.$store
        .dispatch('auth/getAccessToken')
        .then((accessToken) => {
          if (isNew) {
            return axios
              .post(
                `${this.$config.API_URL}/suppliers/${this.supplier.code}/accounts`,
                account,
                {
                  headers: {
                    Authorization: `Bearer ${accessToken}`,
                  },
                }
              )
              .then((result) => {
                // this.accounts.push(result.data)
                this.getAccounts()
                this.$snackbar.show({
                  text: 'Account created successfully',
                })
              })
          } else {
            return axios
              .put(
                `${this.$config.API_URL}/suppliers/${this.supplier.code}/accounts/${account.uid}`,
                account,
                {
                  headers: {
                    Authorization: `Bearer ${accessToken}`,
                  },
                }
              )
              .then((result) => {
                this.accounts.splice(this.accountIndex, 1, result.data)
                this.$snackbar.show({
                  text: 'Account updated successfully',
                })
              })
          }
        })
        .then(() => {
          this.$store.dispatch('modal/close')
        })
        .catch((err) => {
          if (err.response && err.response.status === 400) {
            this.$snackbar.error(
              'Unable to add account: ' +
                err.response.data.errors[0].messages[0]
            )
          } else {
            this.$snackbar.error('Unable to add account: ' + err.message)
          }
        })
    },
    confirmAccountRemoval(index) {
      this.account = this.accounts[index]
      this.accountIndex = index

      const modalParams = {
        content: AppAccountDetails,
        bind: {
          account: this.account,
          onRemove: this.removeAccount,
          onCancel: this.closeModal,
          forRemoval: true,
        },
        style: {
          padding: 'medium',
        },
      }

      this.$store.dispatch('modal/open', modalParams)
    },
    removeAccount(account) {
      this.$store
        .dispatch('auth/getAccessToken')
        .then((accessToken) => {
          return axios
            .delete(
              `${this.$config.API_URL}/suppliers/${this.supplier.code}/accounts/${account.uid}`,
              {
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                },
              }
            )
            .then(() => {
              this.accounts.splice(this.accountIndex, 1)
              this.$snackbar.show({
                text: 'Account deleted successfully',
              })
            })
        })
        .then(() => {
          this.$store.dispatch('modal/close')
        })
    },
    getAccounts() {
      return this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        return axios
          .get(
            `${this.$config.API_URL}/suppliers/${this.supplier.code}/accounts`,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            }
          )
          .then((result) => {
            this.accounts = result.data
          })
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/app-supplier-accounts.vue